import $ from "jquery";
import "slick-carousel";

function initMainSlider() {
  if ($(".js-logo-wall").length) {
    const $logoWall = $(".js-logo-wall");
    
    // Clone all logo items twice and append them to create a more seamless experience
    const $originalItems = $logoWall.children();
    const $firstClone = $originalItems.clone(true);
    const $secondClone = $originalItems.clone(true);
    $logoWall.append($firstClone);
    $logoWall.append($secondClone);
    
    const totalItems = $logoWall.children().length;
    
    $logoWall.slick({
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 4000,
      cssEase: "linear",
      centerMode: true,
      variableWidth: true,
      initialSlide: Math.floor(totalItems / 2), // Start position that provides balanced appearance
    });

    // Once everything is initialized, fade in the slider
    $(".logo-wall__wrapper").animate({opacity: 1}, 500);
  }
}

// Run the function when the document is ready AND images are loaded
$(window).on('load', function() {
  initMainSlider();
});
